import type { DataTableColumn, GridRenderCellParams } from '@/components/custom/erp';
import type { DiaChi } from '@/types/schemas';

export const getDataTableColumns = (): DataTableColumn<DiaChi>[] => [
  {
    field: 'ma_kh',
    headerName: 'Mã khách hàng',
    width: 150,
    renderCell: (params: GridRenderCellParams<DiaChi>) => params.row.ma_kh_data?.customer_code || params.row.ma_kh || ''
  },
  {
    field: 'ten_kh',
    headerName: 'Tên khách hàng',
    width: 200,
    renderCell: (params: GridRenderCellParams<DiaChi>) => params.row.ma_kh_data?.customer_name || ''
  },
  {
    field: 'ma_dc',
    headerName: 'Mã địa chỉ',
    width: 150
  },
  {
    field: 'ten_dc',
    headerName: 'Địa chỉ',
    width: 250
  },
  {
    field: 'lien_he_gh',
    headerName: 'Người liên hệ',
    width: 180
  },
  {
    field: 'dt_gh',
    headerName: 'Số điện thoại',
    width: 150
  },
  {
    field: 'fax_gh',
    headerName: 'Fax',
    width: 150
  },
  {
    field: 'ghi_chu',
    headerName: 'Ghi chú',
    width: 200
  }
];
